const normalizedAllowedStateIds = (user) => {
    const source = Array.isArray(user?.allowedStateIds)
        ? user.allowedStateIds
        : user?.scopeId && user.scopeId !== "ALL"
            ? [user.scopeId]
            : [];
    return source.map((value) => String(value).trim().toLowerCase()).filter(Boolean);
};

export const canAccessState = (user, state) => {
    if (user?.scopeType === "NATIONAL") return true;
    if (user?.scopeType !== "STATE" && user?.scopeType !== "ZONE") return false;

    const allowed = normalizedAllowedStateIds(user);
    return [state?.state_id, state?.slug]
        .map((value) => String(value ?? "").trim().toLowerCase())
        .filter(Boolean)
        .some((identifier) => allowed.includes(identifier));
};

export const canViewOverview = (user) =>
    user?.scopeType === "NATIONAL" || user?.scopeType === "ZONE";

export const defaultStateKey = (user) =>
    user?.scopeType === "STATE" ? normalizedAllowedStateIds(user)[0] || null : null;
